import { IonContent, IonPage, IonText, IonTitle } from '@ionic/react';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import {
  EventDefinition,
  Machine,
  useGetEventDefinitionQuery,
  useGetMachineQuery,
} from '../../api/graphql/generated';
import { EventDefinitionDetail } from '../../components/event/event-definition-detail';
import { LoadingRetry } from '../../components/graphql/LoadingRetry';
import { NestedPageHeader } from '../../components/header/page.header';
import { MachineProgramStatus } from '../../components/machine/machine-program-status';
import { useBeaconRouter } from '../../route/route.hooks';

interface MachineEventDefinitionPageProps {
  teamId: string;
}

interface RouteParams {
  id: string;
  machineId: string;
}

const MachineEventDefinitionPage = (
  props: MachineEventDefinitionPageProps
): ReactElement => {
  const { teamId } = props;
  const { i18n } = useTranslation();
  const params = useParams<RouteParams>();
  const { machineId, id } = params;

  const { data } = useGetMachineQuery({
    variables: { input: { id: machineId, teamId } },
  });

  const {
    data: eventDefinitionData,
    loading,
    error,
    refetch,
  } = useGetEventDefinitionQuery({
    variables: {
      input: {
        id,
      },
    },
  });

  const { builder } = useBeaconRouter();

  const eventDefinition = eventDefinitionData?.getEventDefinition;
  const machine: Machine | undefined = data?.getMachine;
  return (
    <IonPage>
      <NestedPageHeader
        defaultBackRoute={builder.getMachineEventDefinitionsRoute(
          teamId,
          machineId
        )}
      >
        <IonTitle>
          {machine?.name}
          <div className="subtitle header-program-status">
            <MachineProgramStatus machine={machine} />
          </div>
        </IonTitle>
      </NestedPageHeader>
      <IonContent>
        <LoadingRetry
          loading={loading}
          error={error}
          refetch={refetch}
          results={{
            hasResults: eventDefinition !== undefined,
            noResultsComponent: (
              <div className="ion-padding ion-text-center">
                <IonText color="medium">
                  {i18n.t('common:event_error_loading')}
                </IonText>
              </div>
            ),
          }}
        >
          <EventDefinitionDetail
            eventDefinition={eventDefinition as EventDefinition}
          />
        </LoadingRetry>
      </IonContent>
    </IonPage>
  );
};

export { MachineEventDefinitionPage };
